module.exports = __webpack_public_path__ + "img/aidt.3feefbf2.jpg";